module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/fin/expense_vouchers/expense_vouchers-show/expense_vouchers-show.component.scss
// module id = ./src/app/views/fin/expense_vouchers/expense_vouchers-show/expense_vouchers-show.component.scss
// module chunks = main